export default {
  invalidDateMessage: {
    id: 'INPUT-DATEPICKER_INVALID_DATE_ERROR',
    description: 'Input date picker invalid date format text message',
    defaultMessage: 'Invalid date format',
  },
};
